import { TextArea as RadixTextArea } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type TextAreaProps = ComponentPropsWithoutRef<typeof RadixTextArea>

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ size = '2', variant = 'surface', ...props }, ref) => {
    return <RadixTextArea ref={ref} size={size} variant={variant} {...props} />
  }
)

TextArea.displayName = 'TextArea'
